import {
    LIST_ITEM_VISUAL_SIZE_HORIZONTAL_MAP,
    LIST_ITEM_VISUAL_SIZE_VERTICAL_MAP,
    LIST_ITEM_EMOJI_PADDING_MAP,
} from './constants';

// Types
import type { VisualSize } from '$lib/types/Components/SharedTypes';

export const getListItemVisualSizeProps = ({
    srcType,
    visualSize,
    align,
}: {
    srcType: string;
    visualSize: VisualSize;
    align: string;
}) => {
    const size =
        align === 'left'
            ? LIST_ITEM_VISUAL_SIZE_HORIZONTAL_MAP[visualSize]
            : LIST_ITEM_VISUAL_SIZE_VERTICAL_MAP[visualSize];

    const padding = align === 'left' ? 8 : LIST_ITEM_EMOJI_PADDING_MAP[visualSize];

    return {
        size: size,
        emojiPadding: srcType === 'emoji' ? padding : 0,
    };
};
